import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";
import { UserRole } from "@/types";

interface ProtectedRouteProps {
  children: JSX.Element;
  requiredRole?: UserRole;
}

const ProtectedRoute = ({ children, requiredRole }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to the login page, but save the current location they were trying to go to
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  if (requiredRole && user?.role?.name?.toLowerCase() !== requiredRole.toLowerCase() && user?.role?.name?.toLowerCase() !== "admin") {
    // If a specific role is required and the user doesn't have it (and isn't an admin)
    // redirect to home or a not authorized page
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
